<template>
  <div class="premission_index">
    <!-- 编辑弹框 -->
    <div><h2 class="tan_header">设备基本信息</h2></div>
    <el-form label-position='top' :model="formEdit" :rules="rules" :inline="true" ref="formEdit">
      <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
        prop="hospitalId"
        label="所属医院:"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="formEdit.hospitalId"
          placeholder="请选择所属医院"
          class="search_input"
          clearable
          :disabled="true"
        >
          <el-option
            v-for="item in hospitallist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    
        <el-form-item
        label="质控状态:"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="formEdit.status"
          placeholder="请选择设备类型"
          class="search_input"
          clearable
          :disabled="false"
        >
          <el-option
            v-for="item in typelist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item
        label="阴性病例质控比例:"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="formEdit.normalRate"
          placeholder="请选择阴性病例质控比例"
          class="search_input"
          clearable
          :disabled="false"
        >
          <el-option
            v-for="item in normalRatelist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
       <el-form-item
        label="阳性病例质控比例:"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="formEdit.abnormalRate"
          placeholder="请选择阳性病例质控比例"
          class="search_input"
          clearable
          :disabled="false"
        >
          <el-option
            v-for="item in abnormalRatelist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="gender" label="性别:" :label-width="formLabelWidth">
        <el-select v-model="formEdit.gender" placeholder="请选择菜单类型">
          <el-option label="男" value="0" />
          <el-option label="女" value="1" />
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item
        prop="birthday"
        label="出生年月:"
        :label-width="formLabelWidth"
      >
        <el-date-picker
          v-model="formEdit.birthday"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </el-form-item> -->
       
      <!-- <el-form-item prop="studyAge" label="年龄:" :label-width="formLabelWidth">
        <el-input
          placeholder="请输入年龄"
          v-model="formEdit.studyAge"
          autocomplete="off"
        ></el-input>
      </el-form-item> -->

      <!-- <el-form-item prop="remark" label="备注:" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :row="3"
            placeholder="请输入备注"
            v-model="formEdit.remark"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      <!-- <div v-text="formEditlist"></div> -->
      <!-- <el-form-item
          v-if="this.formEdit.level == 2"
          prop="pstlist"
          label="选择医院:"
          :label-width="formLabelWidth"
        >
          <el-cascader
            :options="permissionOptions"
            v-model="formEditlist"
            :props="propd"
          ></el-cascader>
        </el-form-item> -->
      <!-- <div v-text="keysEdit"></div> -->
      <!-- <el-form-item
          prop="menu_ids"
          label="选择菜单:"
          :label-width="formLabelWidth"
        >
          <el-tree
            ref="menusTreeEdit"
            :data="menuList"
            :check-on-click-node="true"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            :default-checked-keys="keysEdit"
            @check="getMenuIdsEdit"
            :check-strictly="isAllSelect"
          />
        </el-form-item> -->
      <!-- <el-form-item
          prop="visible"
          label="是否隐藏:"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="formEdit.visible"
            active-text="显示"
            inactive-text="隐藏"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item> -->
      <!-- <el-form-item
          prop="index"
          label="排序号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入排序号"
            v-model="formEdit.index"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      <!-- <el-form-item
          prop="url"
          label="路由地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入路由地址"
            v-model="formEdit.url"
            autocomplete="off"
          ></el-input>
        </el-form-item> -->
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogFormVisibleEdit = false">取 消</el-button> -->
      <button class="login_Edit" @click="cancelClick">取消</button>
      <!-- <el-button type="primary" @click="postFormEdit">确 定</el-button> -->
      <button @click="postFormEdit" class="ok_Edit">确定</button>
    </div>
  </div>
</template>

<script>
import { AreaCascader } from "vue-area-linkage";
import { pca, pcaa } from "area-data";
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  name: "Premission",
  data() {
    return {
      doctorList:[],
      ids: "",
     
      selected: [], //数组对应的就是选中的那个省市区。根据type来确定是省市区汉字的数组还是编码组成的数组。           //selected[0]省。selected[1]市。selected[2]区。
      pca: pca,
      pcaa: pcaa,
      area_code_array: "",
      times: "",
      regisactive: "未登记",
      regis_id: "0",
      hospitallist: [],
      typelist: [
        {
          name:'开启',
          id:true
        },
        {
          name:'关闭',
          id:false
        },
      ],
      normalRatelist:[
        {
          name:'1%',
          id:'1',
        },
        {
          name:'2%',
          id:'2',
        },{
          name:'4%',
          id:'4',
        },
        {
          name:'5%',
          id:'5',
        },
         {
          name:'10%',
          id:'10',
        }, {
          name:'20%',
          id:'20',
        }, {
          name:'25%',
          id:'25',
        }, {
          name:'50%',
          id:'50',
        }, {
          name:'100%',
          id:'100',
        },
      ],
      abnormalRatelist:[
        {
          name:'1%',
          id:'1',
        },
        {
          name:'2%',
          id:'2',
        },{
          name:'4%',
          id:'4',
        },
        {
          name:'5%',
          id:'5',
        },
         {
          name:'10%',
          id:'10',
        }, {
          name:'20%',
          id:'20',
        }, {
          name:'25%',
          id:'25',
        }, {
          name:'50%',
          id:'50',
        }, {
          name:'100%',
          id:'100',
        },
      ],
      modality: "",
      listlist: "",
      keysEdit: [],
      tableDatas: [],
      studyNo: "",
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      username: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "",
      list: "",
      formEditlist: [],
      pids: "",
      formEdit: {
        status:'',
        abnormalRate:'',
        normalRate:'',
        hospitalId:'',
      },
      rules: {
        name: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        studyNo: [{ required: true, message: "检查号", trigger: "blur" }],
        // hospitalId: [
        //   { required: true, message: "请输入身份证号", trigger: "blur" },
        // ],
        // phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        ip: [
          { required: true, message: "请输入IP", trigger: "blur" },
        ],
        port: [{ required: true, message: "请输入端口", trigger: "blur" }],
        aeTitle: [{ required: true, message: "请输入AEtitle", trigger: "blur" }],
        // type: [{ required: true, message: "请选择设备类型", trigger: "blur" }],
        hospitalId: [
          { required: true, message: "请选择所属医院", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    console.log(this.$route.query);
    this.ids = this.$route.query.id;
    this.getList();
    this.getListMyHospital()
  },

  watch: {
    list(newVal) {
      this.form.hospitalIds = newVal.join();
      console.log(this.form.hospitalIds);
    },
  },
  methods: {
    getList() {
       this.$http.get(this.GLOBAL.BASE_URL + 'v1/quality-control-settings/' + this.ids + '?token=' + sessionStorage.getItem("token"))
     .then(response => {
      console.error('response',response);
      this.formEdit = response.data.data;
      this.formEdit.type = this.formEdit.type.type
      console.log('this.formEdit',this.formEdit)
     })
     .catch(err => {
      console.error(err);
     });
    },
    handleChange(value) {
      console.log(value);
      if (value) {
        this.pids = value.join("/");
        console.log(this.pids);
      }
    },
    cancelClick() {
      this.$router.push({
         path: "/study/quality-control-settings",
      });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
     getListMyHospital() {
      depot
        .get({
          url: "/v1/hospital/listMyHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.hospitallist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postFormEdit() {
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
        this.$http.put(this.GLOBAL.BASE_URL + 'v1/quality-control-settings/' + this.ids + '?token=' + sessionStorage.getItem("token"), this.formEdit)
					.then(response => {
						console.log(response)
            if(response.data.code == 200){
              // this.formEdit.fileId = response.data.data.id
              // this.filesId.push(response.data.data.id)
              // console.log('response',this.filesId)
               this.$message({
          message: '新增成功',
          type: "success",
        });
                this.$router.push({
                  path: "/study/quality-control-settings",
                });
              return
            }
             this.$message({
          message: response.data.msg,
          type: "error",
        });
        // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
					})
					.catch(err => {
						console.error(err);
					});
          // depot
          //   .post({
          //     url: "/v1/devices",
          //     data: this.formEdit,
          //   })
          //   .then((res) => {
          //     console.log(res);
          //     if (res.success == true) {
          //       this.$message({
          //         message: "保存成功",
          //         type: "success",
          //       });
          //       this.$router.push({
          //         path: "/study/record",
          //       });
          //       return;
          //     }
          //     this.$message({
          //       message: res.msg,
          //       type: "error",
          //     });
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getMenuLinkageList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
    beforeRouteLeave(to,from,next){
   to.meta.keepAlive = false
   next(0)
 },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
  margin-top: 0px!important;
}
.borders {
  width: 100%;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 19px;
}
.tan_header {
  margin-left: 0px;
  margin-bottom: 15px;
}
/deep/.area_box .area-select .area-selected-trigger {
  padding: 0px 10px !important;
}
.search_click {
  color:#fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.box_cycle {
  display: inline-flex;
}
.box_regis {
  display: inline-flex;
  margin-bottom: 28px;
}
.box_cycle span:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: 1px solid #fff;
}
.box_cycle span:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: 1px solid #fff;
}
.premission_index {
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  box-sizing: border-box;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0px!important;
}
.search_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 100%;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 20px;
  margin-top: 20px;
  text-align: right;
}
.elAdd {
  margin-bottom: 10px;
}
.cyclestyle {
  cursor: pointer;
  width: 62px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}
.active {
  background: #009b43;
  cursor: pointer;
  color: #fff;
}
.register {
  cursor: pointer;
  width: 139px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  background: #c4c4c4;
  font-size: 14px;
  opacity: 0.8;
}


.registeractive {
  cursor: pointer;
  color: #fff;
  background: #009b43;
}
.statusone {
  color: #ed6f00 !important;
}
/deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}

/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #009b4 3 !important;
  color: #fff !important;
}
/deep/.area_box .area-select .area-selected-trigger {
  display: flex;
  align-items: center;
  /* color: #dcdfe6 !important; */
}
/deep/.el-form-item {
  width: 23%!important;
}
/deep/.el-form-item .el-form-item__label {
  width: 135px!important;
}
.widthss {
  width: 100%!important;
}
/deep/.el-form--inline .el-form-item__content {
    width: calc(100% - 20px)!important;
}
</style>




// WEBPACK FOOTER //
// src/views/editquality/index.vue